import * as v from 'valibot';

import { persistentStore } from '@store/persistentStore';

const UIDStateSchema = v.object({
  state: v.object({
    uid: v.string(),
  }),
});

/**
 * Handles cross-tab persistent store rehydration.
 * All tabs share the same localStorage key. Skip rehydration when the write
 * belongs to a different user (e.g. a second tab logged in as a different account).
 */
function handleStorage(event: StorageEvent): void {
  if (!event.isTrusted || event.key !== persistentStore.persist.getOptions().name || !event.newValue) {
    return;
  }
  try {
    const incoming: unknown = JSON.parse(event.newValue);
    const parsed = v.parse(UIDStateSchema, incoming);
    const incomingUid = parsed.state.uid;
    const currentUid = persistentStore.getState().uid;
    if (incomingUid && currentUid && incomingUid !== currentUid) {
      return;
    }
  } catch {
    // Malformed JSON — fall through and rehydrate
  }
  void persistentStore.persist.rehydrate();
}

export function initializeTabSessionCoordinator(): void {
  globalThis.addEventListener('storage', handleStorage);
}

export function cleanupTabSessionCoordinator(): void {
  globalThis.removeEventListener('storage', handleStorage);
}
